var React = require('react');

function BaselineFastForward24px (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

BaselineFastForward24px.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = BaselineFastForward24px;

BaselineFastForward24px.default = BaselineFastForward24px;
